export default function Flag(props){
    return (
        <div className="flag-container">
            <img className={`flag ${props.country}-flag`} src={`images/flags/${props.country}.svg`} />
        </div>
    )
}